module.exports = __webpack_public_path__ + "static/img/9.a73d257.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/9.png
// module id = UnDt
// module chunks = 0